__turbopack_context__.v({
  "contentContainer": "modal-module-scss-module__yNCdFW__contentContainer",
  "controls": "modal-module-scss-module__yNCdFW__controls",
  "inactive": "modal-module-scss-module__yNCdFW__inactive",
  "modal": "modal-module-scss-module__yNCdFW__modal",
});
